import { QuotationMode, QuotationModes } from "../quotation-modes";

export interface IMilestone {
    code: string;
    order: number;
    position: number;
    icon: string;
    label: string;
}

export class QuoteMilestone implements IMilestone {
    code: string;
    order: number;
    position: number;
    icon: string;
    label: string;

    constructor() {
        this.code = '';
        this.order = 0;
        this.position = 0;
        this.icon = '';
        this.label = '';
    }
}

export const milestones: IMilestone[] = [
    {
        code: 'submitted',
        order: 0,
        position: 0,
        icon: 'new',
        label: 'Submitted',
    },
    {
        code: 'ready',
        order: 1,
        position: 1,
        icon: 'book-2',
        label: 'Ready',
    },
    {
        code: 'accepted',
        order: 2,
        position: 2,
        icon: 'delivered',
        label: 'Accepted',
    },
    {
        code: 'rejected',
        order: 2,
        position: 2,
        icon: 'cancelled',
        label: 'Rejected',
    },
    {
        code: 'expired',
        order: 2,
        position: 2,
        icon: 'timer_off',
        label: 'Expired',
    },
];

export function MilestoneConst( modes: QuotationMode[] = QuotationModes.slice() ) {
    return modes.map( _ => milestones )
        .reduce(( a, c ) => [ ...a, ...c ], [] )
        .filter(( v, i, a ) => a.map( m => m.code ).indexOf( v.code ) === i )
        .sort(( a, b ) => a.order - b.order );
}
